import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { listenToIncomingGlobal } from "../../redux/Messages/MessagesAction";
import { bumpTitleAlert } from "../../util/TitleAlerts";
import { ding } from "../../util/Sound";

function notify({ title, body }) {
  if ("Notification" in window) {
    if (Notification.permission === "granted") {
      new Notification(title, { body });
    } else if (Notification.permission !== "denied") {
      Notification.requestPermission();
    }
  }
  bumpTitleAlert();
  ding();
}

function AppNotifications({ userDetails, activeThread }) {
  const meEmail = userDetails?.email?.toLowerCase();
  const activeThreadId = activeThread?.id; // ✅ from Redux
  const lastIds = useRef(new Set());

  useEffect(() => {
    
    if (!meEmail) return;
    const stop = listenToIncomingGlobal({
      meEmail,
      onIncoming: (m) => {
        if (m.senderEmail === meEmail) return;

        if (Array.isArray(m.readBy) && m.readBy.includes(meEmail)) return;
        
        if (lastIds.current.has(m.id)) return;
        lastIds.current.add(m.id);

        if (lastIds.current.size > 500) {
          lastIds.current = new Set([...lastIds.current].slice(-250));
        }

        // 🔑 Only notify if not in focus OR in another thread
        if (!document.hasFocus() || m.threadId !== activeThreadId) {
          notify({ title: "New message", body: (m.text || "Attachment").slice(0, 80) });
          
        }
      },
    })(() => {});
    return () => typeof stop === "function" && stop();
  }, [meEmail, activeThreadId]);

  return null;
}

export default connect(
  (s) => ({ 
    userDetails: s.loginAuth.userDetails,
    activeThread: s.activeThread 
  }),
  null
)(AppNotifications);
